import React from 'react';
import { Link } from 'react-router-dom';

const Testimonial: React.FC = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4 text-center">
        <h2 className="text-4xl md:text-5xl font-black mb-8 italic uppercase">
          "THE BEST COMPANY TO<br />
          HELP YOU IMPLEMENT AI,<br />
          HANDS DOWN!!!"
        </h2>
        
        <p className="text-gray-600 mb-16 text-lg">
          - Terry Halstead
        </p>
        
        <div className="mb-8">
          <Link 
            to="/contact" 
            className="bg-primary text-white px-8 py-3 rounded-md font-bold text-lg inline-block transform hover:scale-105 transition-all duration-200 uppercase animate-wiggle animate-pulse-glow"
            style={{ 
              textShadow: '0 2px 4px rgba(0,0,0,0.3)',
              animation: 'wiggle 3s ease-in-out infinite, pulse-glow 2s ease-in-out infinite'
            }}
          >
            APPLY TO BECOME A CLIENT
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Testimonial; 